export default {
    approvals: "Aprobaciones",
    delegates: "Delegados",
    employees: "Empleados"
}